import type { Locale } from '@/i18n/routing';

/** Three-letter display code for the language switcher. */
export function getLocaleCode(locale: Locale | string): string {
    switch (locale) {
        case 'en':
            return 'ENG';
        case 'cs':
            return 'CZE';
        case 'es':
            return 'SPA';
        case 'ro':
            return 'ROM';
        case 'pl':
            return 'POL';
        default:
            return '';
    }
}
